module.exports = __webpack_public_path__ + "static/media/pic3.4503d0d7.jpg";